import {
    AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges,
    OnDestroy, ViewChild,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { fromEvent, Subscription, debounceTime } from 'rxjs';

@Component({
    selector: 'i360-ellipsis',
    template: `
        <span #container
              matTooltipClass="wide-tooltip"
              [matTooltip]="showTooltip ? (tooltip||text) : '' ">
            {{ text }}
        </span>`,
    styles: [`
        :host {
            display: flex;
            max-width: 100%;
        }
        span {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    `],
})
export class EllipsisComponent implements AfterViewInit, OnDestroy, OnChanges {
    static onResize = new EventEmitter();
    subscribe = Subscription.EMPTY;

    @ViewChild('container', {static: true}) container: ElementRef;
    @ViewChild(MatTooltip, {static: true}) matTooltip: MatTooltip;

    @Input() tooltip: string = '';
    @Input() text: string;

    showTooltip: boolean;
    constructor(private zone: NgZone, private detector: ChangeDetectorRef) {}
    normalize() {
        const elem = this.container.nativeElement;
        const show = elem.offsetWidth < elem.scrollWidth;
        if (show !== this.showTooltip) {
            this.showTooltip = show;
            // this called after change detection synchronously (after updating html for "text"
            // parameter), so need to trigger it again to pass new parameter to tooltip
            this.detector.markForCheck();
        }
    }

    ngAfterViewInit() {
        this.subscribe = EllipsisComponent.onResize.subscribe(() => this.normalize());
    }

    ngOnDestroy() {
        this.subscribe.unsubscribe();
    }
    ngOnChanges() {
        const sub = this.zone.onStable.subscribe(() => {
            sub.unsubscribe();
            this.normalize();
        });
    }

}

fromEvent(window, 'resize').pipe(
    debounceTime(1000),
).subscribe(() => EllipsisComponent.onResize.emit());
